import React from "react";
import style from "./index.module.scss";
import { Button, Tooltip } from "antd";
import { BiUndo } from "react-icons/bi";
import { useHistory } from "react-router-dom";
import { QuestionnaireProps } from "../../../../../service";
import BriefInfo from "../../../../../Components/BriefInfo";

interface HeaderProps {
    headerData: QuestionnaireProps;
}

export default function Header({ headerData }: HeaderProps) {
    const history = useHistory();

    return (
        <div className={style.root}>
            <div className={style.wrapper}>
                <div className={style.left}>
                    <h1 className={style.title}>
                        <Tooltip
                            title={headerData.description}
                            placement="bottomLeft">
                            <span>{headerData.description}</span>
                        </Tooltip>

                        <Button
                            className={style.back}
                            onClick={() => history.goBack()}>
                            <BiUndo size={16} /> 返回
                        </Button>
                    </h1>

                    <BriefInfo item={headerData} />
                </div>
            </div>
        </div>
    );
}
